import {Injectable, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {GlobalPropertyUserDB} from '../../interfaces/globalproperty.interface';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';


const UNKNOWN_PROPERTY: GlobalPropertyUserDB = {
  active: false,
  id: '',
  name: '',
  role: ''
};


@Injectable()
export class GlobalPropertyService implements OnDestroy {
// Initial State - No Properties loaded;
  private subject = new BehaviorSubject(UNKNOWN_PROPERTY);

  property$: Observable<GlobalPropertyUserDB> = this.subject.asObservable();

  constructor() {
  }

  /**
   * Update Value of Global Property
   * @param {GlobalPropertyUserDB} property
   */
  setPropertyValue(property: GlobalPropertyUserDB): void {
    if (property) {
      if (property.active) {
        this.subject.next(property);
      } else {
        this.resetGlobalProperty();
      }
    }
  }

  /**
   * Set Value of Global Property to UNKNOWN
   */
  resetGlobalProperty() {
    this.subject.next(UNKNOWN_PROPERTY);
  }

  ngOnDestroy() {
    this.subject.next(UNKNOWN_PROPERTY);
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/local/global-property.service.ts